<template>
  <v-col cols="12">
    <div class="text-center">
      <v-dialog
        v-model="loading"
        persistent
        width="300">
        <v-card
          color="primary"
          dark>
          <v-card-text>
            Загружаются данные отчета
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-row align="center" justify="start">
      <v-select v-if="isProjects"
                v-model="selectedProjects"
                :items="projects"
                @change="updateProjects"
                item-text="name"
                item-value="id"
                multiple
                label="Проекты" />
      <BaseDatePicker :value="lowestDate"
                      :disabled="isDatesActive"
                      @dateUpdated="dateLowerUpdated"
                      label="С" />
      <BaseDatePicker :value="highestDate"
                      :disabled="isDatesActive"
                      @dateUpdated="dateHigherUpdated"
                      label="По" />
      <BaseAutoComplete ref="users"
                        v-if="isUsersList"
                        :items="users"
                        :max-elements="10"
                        :value="selectedUsers"
                        :sel-all="true"
                        @updateSelected="updateUsers"
                        style="margin-left: 20px;  margin-right: 20px;"
                        label="Сотрудники"
                        item-text="full_name"
                        item-value="id" />
      <BaseAutoComplete v-if="isPlacesList"
                        :items="places"
                        :value="placesSelected"
                        @updateSelected="updatePlaces"
                        style="margin-left: 20px;"
                        label="Места выхода" />
      <BaseAutoComplete v-if="isGendersList"
                        :items="[{name: 'М', value:'М'}, {name: 'Ж', value:'Ж'}, {name: 'Все', value:'Все'}]"
                        :value="gendersSelected"
                        @updateSelected="updateGenders"
                        style="margin-left: 20px;"
                        label="Пол" />
      <v-btn @click="submitSearch"
             color="primary"
             class="mb-2"
             style="margin-left: 20px;">
        Поиск
      </v-btn>
    </v-row>
  </v-col>
</template>
<script>
import BaseAutoComplete from './BaseAutoComplete'
import BaseDatePicker from './BaseDatePicker'
import {mapState} from 'vuex'

export default {
name: "BaseControlElement",
  components: {BaseAutoComplete,BaseDatePicker},
  props: {

    isUsersList: {
      type: Boolean,
      default: false
    },
    isProjects: {
      type: Boolean,
      default: true
    },
    isPlacesList: {
      type: Boolean,
      default: false
    },
    isGendersList: {
      type: Boolean,
      default: false
    },
    isDatesActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      loading: false,
      placesSelected:[],
      gendersSelected: [],
      selectedYear:2020,
      selectedUsers: [],
      selectedProjects: []
    }
  },

  computed: mapState({
    users: state => state.tableData.users,
    places: state => state.tableData.places,
    projects: state => state.tableData.projects
  }),
  watch: {
    selectedYear (newValue) {
      this.lowestDate = this.firstDayOfTheYear(newValue)
      this.highestDate = this.lastDayOfTheYear(newValue)
    }
  },
  created () {
    if (this.isPlacesList) this.$store.dispatch("tableData/loadPlaces")
    if (this.isUsersList) this.$store.dispatch("tableData/loadUsers")
    this.$store.dispatch("tableData/loadProjects")
  },
  methods: {
    updateUsers (newVal) {
      this.selectedUsers = newVal
      this.$emit('update:selectedUsers', this.selectedUsers)

    },
    dateLowerUpdated (newVal) {
      this.lowestDate = newVal
      this.$emit('update:lowestDate', newVal)

    },
    dateHigherUpdated (newVal) {
      this.highestDate = newVal
      this.$emit('update:highestDate', newVal)
    },
    updatePlaces (newVal) {
      this.placesSelected = newVal
      this.$emit('update:placesSelected', newVal)

    },
    updateGenders (newVal) {
      this.gendersSelected = newVal
      this.$emit('update:gendersSelected', newVal)

    },
     submitSearch () {
      this.$emit('submitSearch')
      this.$emit('update:loading', true)
    },
    updateProjects (newVal) {
      this.selectedProjects = newVal
      this.$emit('update:selectedProjects', newVal)

    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseControlElement.vue